<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none"
  >
    <path
      d="M23.9375 7.21866C24.2643 10.9535 21.8117 14.4078 19.4996 16.8197C17.1557 19.2649 14.6957 20.905 14.437 21.073C14.436 21.0737 14.4352 21.0746 14.4342 21.0752L14.4325 21.0774L14.4314 21.0765C14.1909 21.233 13.9163 21.3294 13.6303 21.3544C13.3441 21.3794 13.0564 21.3325 12.7922 21.2199C12.7913 21.2195 12.7901 21.2196 12.7892 21.2192C12.7882 21.2188 12.7871 21.2188 12.7862 21.2184L12.7861 21.2175C12.4978 21.0951 9.79316 19.9069 7.06274 17.9078C4.36699 15.934 1.3518 12.958 1.02505 9.22324L1.02496 9.22227L1.00427 8.8849C0.942566 7.20104 1.50661 5.54896 2.59483 4.25208C3.75561 2.86871 5.41809 2.00242 7.2169 1.843L7.21787 1.84292C9.01339 1.68583 10.715 2.17016 12.0408 3.18647C13.17 1.95537 14.7617 1.18292 16.5572 1.02583L16.5582 1.02575L16.8955 1.00505C18.5794 0.94335 20.2315 1.50739 21.5284 2.59561C22.9117 3.7564 23.778 5.41887 23.9374 7.21769L23.9375 7.21866Z"
      fill="#CF2A1E"
      stroke="white"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {};
</script>
